import { ReactNode } from "react";

import { cn } from "@/styles/cn";

/**
 * Utilizado para centrar horizontal y verticalmente un elemento
 * Tipico en avisos de respuesta
 */
export function CenterLayout({ children, className }: { className?: string; children: ReactNode }) {
  return (
    <div
      className={cn(
        "flex h-full min-h-[300px] w-full flex-col items-center justify-center pt-8 text-center text-gray-400",
        className,
      )}
    >
      {children}
    </div>
  );
}
